export interface ValidationResult {
    stepId: string;
    isValid: boolean;
}
